import type {Toast} from "primereact/toast";
import {useTranslation} from "react-i18next";

import type {ValuationData} from "@reva/shared/valuation-data";

import {useUnloadValuation} from "./valuationLoadHooks";

/** Wartezeit, bis nach „Zugriff verloren“ zur Startseite gewechselt wird — der Warn-Toast soll kurz lesbar sein. */
export const ACCESS_LOST_REDIRECT_DELAY_MS = 1500;

/**
 * Auswertung der Backend-Notification `accessLostByReassignment` nach einer Owner-Zuweisung (#18343, #19302 Z-B1):
 * Hat sich der Nutzer durch die Zuweisung an eine andere Person selbst den Zugriff entzogen, zeigt der zurückgegebene
 * Handler den Warn-Toast und kehrt nach {@link ACCESS_LOST_REDIRECT_DELAY_MS} zur Startseite zurück (alles
 * zurückgesetzt). Einzige Stelle dafür — Aufrufer zeigen den Toast nicht selbst.
 * @return Handler, `true` wenn der Zugriff verloren ging
 */
export function useAccessLostByReassignmentHandler(): (
    response: ValuationData | null | undefined,
    toast: Toast | null | undefined,
) => boolean {
    const {t} = useTranslation();
    const unloadValuation = useUnloadValuation();

    return (response, toast) => {
        if (response?.notifications?.accessLostByReassignment?.notified !== true) return false;
        toast?.show({
            severity: "warn",
            summary: "Warn",
            detail: t("order.owner.accessLostByReassignment"),
        });
        setTimeout(() => {
            void unloadValuation("/");
        }, ACCESS_LOST_REDIRECT_DELAY_MS);
        return true;
    };
}
